import { render, staticRenderFns } from "./UserFormComponent.vue?vue&type=template&id=0a5a4f54&"
import script from "./UserFormComponent.vue?vue&type=script&lang=js&"
export * from "./UserFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports